import React from 'react'
import PropTypes from 'prop-types'

const Price = ({ value, classNames }) => {
  const [integer, fraction] = value.split('.')
  return (
    <div className={classNames.wrapper}>
      <span className={classNames.bigPrice}>{integer}.</span>
      <span className={classNames.smallPrice}>{fraction}</span>
    </div>
  )
}

Price.propTypes = {
  value: PropTypes.string.isRequired,
  classNames: PropTypes.shape({
    wrapper: PropTypes.string.isRequired,
    bigPrice: PropTypes.string.isRequired,
    smallPrice: PropTypes.string.isRequired
  }).isRequired
}

export default Price
